module.exports = __webpack_public_path__ + "img/ycc_rewards_1920.09866cb0.png";